/**
 * GSAP setup — owns scroll-driven animation (ScrollTrigger). Motion owns component
 * transitions and anime.js owns micro-details; see src/lib/animation/README in index.ts.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

// Ease used by every scroll reveal so GSAP motion matches Motion's EASE curve.
gsap.defaults({ ease: 'power3.out', duration: 0.7 });

// Avoid a full ScrollTrigger recalculation on every mobile address-bar resize.
ScrollTrigger.config({ ignoreMobileResize: true });

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.(REDUCED_MOTION_QUERY).matches === true;
}

export { gsap, ScrollTrigger, useGSAP };
